import { BottomSheetHandleProps } from '@gorhom/bottom-sheet'
import React from 'react'

export const EmptyHandleComponent = ({
  animatedIndex,
  animatedPosition,
}: BottomSheetHandleProps) => <></>
